<template>
  <WidgetNode :node="getWidgetNode(widget)" class="widget-item" />
</template>

<script>
  import { simpleTypeMixin } from '@/helpers';
  import WidgetNode from '@/components/templates/viewer/templateWidgets/WidgetNode.vue';
  import { WIDGET_TYPES } from '@/models/layoutDesigner';

  export default {
    name: 'TemplateLayer',

    props: {
      widget: {
        type: Object,
        default: () => null,
      },
    },

    mixins: [simpleTypeMixin],

    components: {
      WidgetNode,
    },

    methods: {
      getWidgetNode(widget) {
        return {
          data: widget,
          id: widget.object.type || WIDGET_TYPES.PLAYLIST,
        };
      },
    },
  };
</script>
